<script setup lang="ts">
import CoreChipAction from 'frontcore/views/chips/chip/views/CoreChipAction.vue'
import i18n from 'frontcore/i18n'
import SVGIcon from 'frontcore/views/icons/SVGIcon.vue'
import useCalendarHeader from 'frontcore/presentation/calendar/domain/useCalendarHeader'
import { CalendarModeOptions } from 'frontcore/presentation/calendar/domain/types'
import { toRefs, watch } from 'vue'

interface Props {
  mode: number
  month: number
  selectionMode: number
  year: number
}

const props = defineProps<Props>()

const { selectionMode } = toRefs(props)

const emit = defineEmits<{
  (e: 'update:month', value: number): void,
  (e: 'update:year', value: number): void,
  (e: 'update:mode', value: CalendarModeOptions): void,
  (e: 'today'): void,
}>()

const numberOfVisibleYears = 0

const {
  viewmodel,
  goToToday,
  nextMonth,
  previousMonth,
  changeCalendarMode,
  setCalendarHeaderInfo,
  showTodayButton,
} = useCalendarHeader(
  props.mode,
  props.month,
  props.year,
  numberOfVisibleYears,
  selectionMode
)

watch(
  () => props.mode,
  () => {
    setCalendarHeaderInfo(props.month, props.year)
  }
)

const previous = () => {
  previousMonth()
  emit('update:year', viewmodel.year)
  emit('update:month', viewmodel.month)
}

const next = () => {
  nextMonth()
  emit('update:year', viewmodel.year)
  emit('update:month', viewmodel.month)
}
const moveToToday = () => {
  goToToday()
  emit('update:year', viewmodel.year)
  emit('update:month', viewmodel.month)
  emit('today')
}

const { t } = i18n.global

const showMonthSelector = () => {
  changeCalendarMode(CalendarModeOptions.SELECT_MONTH)
  emit('update:mode', viewmodel.mode)
}
</script>

<template>
  <div class="flex items-center gap-6">
    <CoreChipAction
      v-show="showTodayButton"
      :label="t('common.messages.today')"
      class="core-calendar__menu__header-action"
      dataTest="calendar-today-chip"
      @click="moveToToday" />
    <div class="calendar-header flex items-start justify-between user-select-none">
      <SVGIcon
        class="pointer"
        iconName="ChevronLeft"
        data-test="calendar-header-previous-month-icon"
        @click="previous" />
      <span
        class="headlines--headline-04 capitalize-text flex justify-content-center align-content-start"
        data-test="calendar-header-month-name"
        @click="showMonthSelector">
        {{ viewmodel.monthName }} {{ viewmodel.year }}
      </span>
      <SVGIcon
        class="pointer"
        iconName="ChevronRight"
        data-test="calendar-header-next-month-icon"
        @click="next" />
    </div>
  </div>
</template>
